import { i18nFilter } from "app/filters/i18nFilter";
import React from "react";
import { RecommendedWebsiteGroupBanner } from "pro-features/components/WebsiteRecommendationEngine/src/RecommendedWebsiteGroupBanner";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const i18n = i18nFilter();

export interface IBannerProps {
    displayInPage?: string | string[];
    displayInTab?: string;
    userDataBannerKey?: string;
    displayShowMore?: boolean;
    text: string;
    title: string;
}

export const InfoBanner: React.FunctionComponent<IBannerProps> = (props) => {
    const { displayInPage, displayInTab, userDataBannerKey, displayShowMore, text, title } = props;
    const params = proNavigator.getParams();
    const state = proNavigator.current();
    const currentPage = state?.name;
    const selectedTab = params?.selectedTab;
    const isCurrentPage = () => {
        return displayInPage.includes(currentPage);
    };
    const hideBannerUserPreference = userDataBannerKey && (PreferencesService.get(userDataBannerKey) || false);
    const [hideBanner, setHideBanner] = React.useState(hideBannerUserPreference);
    if (
        (displayInPage && !isCurrentPage()) ||
        (displayInTab && selectedTab !== displayInTab) ||
        (!displayInPage && !displayInTab)
    ) {
        return null;
    }
    const onCloseClick = () => {
        setHideBanner(true);
        userDataBannerKey && PreferencesService.add({ [userDataBannerKey]: true });
    };
    return (
        !hideBanner && (
            <RecommendedWebsiteGroupBanner
                onCloseClick={onCloseClick}
                title={i18n(title)}
                text={i18n(text)}
                displayShowMore={displayShowMore ? displayShowMore : false}
                containerPadding={"0px 36px 0px 16px"}
            />
        )
    );
};
